<template>
    <div class="board" style="position:relative" v-hasPermi="['arrangement:exam:update','arrangement:exam:save']">
        <paperPreview v-if="confirmPreview" @saved="handleSaved"></paperPreview>
        <template v-else>
            <div class="title">
                <span><el-button type="text" icon="el-icon-arrow-left" @click="back()">{{ examEditTextConfig.back.name }}</el-button><el-divider
                        direction="vertical"></el-divider><span
                        class="name">{{ $route.query.id ? examEditTextConfig.edit : examEditTextConfig.add }}</span></span>
            </div>
            <el-tabs v-model="activeName" tab-position="left" :before-leave="beforeTabLeave">
                <el-tab-pane :label="examEditTextConfig.base.title" name="0">
                    <base-exam ref="base" @setExamIdAndCategory="setExamIdAndCategory" @saved="handleSaved"></base-exam>
                </el-tab-pane>
                <el-tab-pane :label="examEditTextConfig.advanced.title" name="4" :disabled="examId==null">
                    <advanced-setting ref="advanceRef" :examId="examId" :examStatus="examStatus"
                                      @saved="handleSaved"></advanced-setting>
                </el-tab-pane>
                <el-tab-pane :label="examEditTextConfig.paper.title" name="1" :disabled="examId==null">
                    <paper ref="paper" :examId="examId" :examCategory="examCategory" :examStatus="examStatus" @saved="handleSaved"></paper>
                </el-tab-pane>
                <el-tab-pane :label="examEditTextConfig.examinee.title" name="2" :disabled="examId==null">
                    <examinee :examId="examId" :examStatus="examStatus"></examinee>
                </el-tab-pane>
                <el-tab-pane :label="examEditTextConfig.result.title" name="3" :disabled="examId==null">
                    <displaySetting :examId="examId" :examStatus="examStatus" @saved="handleSaved"></displaySetting>
                </el-tab-pane>
            </el-tabs>
        </template>
    </div>
</template>
<script>
import baseExam from './baseExam.vue'
import paper from './paper.vue'
import examinee from './examinee.vue'
import displaySetting from './displaySetting.vue'
import paperPreview from '@/components/paperPreview/index.vue'
import AdvancedSetting from "./AdvancedSetting.vue";
import {getExam} from "@/api/arrangement";

export default {
    components: {
        baseExam, paper, paperPreview, examinee, displaySetting, AdvancedSetting
    },
    data() {
        return {
            activeName: '0',
            importDialogVisible: false,
            examPlanOptions: [],
            certificateOptions: [],
            certificateGradeOptions: [],
            subjectOptions: [],
            arrangeExamStatusOptions: [],
            examPaperStatusOptions: [],
            examTypeOptions: [],
            examId: this.$route.query.id,
            examCategory: null,
            examStatus: 0,
            //tab修改是否已保存,
            saved: true,
        };
    },
    computed: {
        confirmPreview() {
            return this.$store.state.arrangeExam.confirmPreview
        },
        examEditTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.examEdit
        },
    },
    methods: {
        handleSaved(saved) {
            this.saved = saved
        },
        beforeTabLeave(active, old) {
            return new Promise((resolve, reject) => {
                if (!this.saved) {
                    let changeTab = this.examEditTextConfig.changeTab
                    this.$confirm(changeTab.message, changeTab.title, {
                        confirmButtonText: changeTab.ok,
                        cancelButtonText: changeTab.cancel,
                        type: 'warning'
                    }).then(() => {
                        this.saved = true
                        //更新页面数据
                        if (old === '0') {
                            this.$refs.base.getExamData()
                        }
                        if (old === '1') {
                            this.$store.state.arrangeExam.isBack = false
                            this.$refs.paper.getExamPapers()
                        }
                        if (old === '4') {
                            this.$refs.advanceRef.getExamData(this.examId)
                        }
                        resolve()
                    }).catch(e => {
                        reject()
                    });
                } else {
                    resolve()
                }
            })
        },
        close(data) {
            if (data) {
                this.getData()
                this.$refs.arrangeExam.search(1)
            }
        },
        getData() {
            this.$store.dispatch("getExamPlan").then(res => {
                this.examPlanOptions = res.data
            });
            this.$store.dispatch("getExamCertificate").then(res => {
                this.certificateOptions = res.data
            });
            this.$store.dispatch("getDict", 'credential_level').then(res => {
                this.certificateGradeOptions = res.data
            });

            this.$store.dispatch("getDict", 'arrangement_exam_status').then(res => {
                this.arrangeExamStatusOptions = res.data
            });
            this.$store.dispatch("getDict", 'arrangement_paper_status').then(res => {
                this.examPaperStatusOptions = res.data
            });
            this.$store.dispatch("getDict", 'exam_category').then(res => {
                this.examTypeOptions = res.data
            });
            if (this.$route.query.id) {
                getExam(this.$route.query.id).then(res => {
                    if (res.status === 200) {
                        this.examCategory = res.data.examCategory
                        this.examStatus = res.data.examStatus
                    }
                })
            }
        },
        setExamIdAndCategory(id, examCategory) {
            this.examId = id
            this.examCategory = examCategory
            this.$refs.advanceRef.getExamData(id)
            const currentQuery = {...this.$route.query};
            if (!('examId' in currentQuery)) {
                currentQuery['examId'] = this.examId;
                // 使用replace而不是push，避免产生新的历史记录
                this.$router.replace({
                    query: currentQuery
                });
            }
        },
        back() {
            let back = this.examEditTextConfig.back
            if (!this.saved) {
                this.$confirm(back.message, back.title, {
                    confirmButtonText: back.ok,
                    cancelButtonText: back.cancel,
                    type: 'warning'
                }).then(() => {
                    this.$router.push({path: '/arrangeExam'})
                })
            } else {
                this.$router.push({path: '/arrangeExam'})
            }
        }
    },
    created() {
        this.getData()
    },
};
</script>
<style scoped>
.el-tabs >>> .el-tabs__header {
    margin-bottom: 19px;
}

.el-tabs >>> .el-tabs__nav .el-tabs__item {
    padding: 15px 0;
    line-height: 36px;
    height: 63px;
    font-weight: 600;
    font-size: 16px;
    padding-right: 20px;
}

.el-tabs >>> .el-tabs__nav-wrap::after {
    height: 1px;
}

::v-deep .el-tabs__item:focus.is-active.is-focus:not(:active) {
    -webkit-box-shadow: none;
    box-shadow: none;
}


</style>
